module.exports = __webpack_public_path__ + "tape/tape.css";


//////////////////
// WEBPACK FOOTER
// ./src/tape/tape.css
// module id = 20
// module chunks = 0